"use client";

import useSession from "@/hooks/useSession";
import emailToName from "@/utils/emailToName";
import nameToColorHash from "@/utils/nameToColorHash";
import nameToInitials from "@/utils/nameToInitials";
import { Icon } from "@iconify/react";
import { Dropdown } from "flowbite-react";
export const DisconnectedAvatar = ({
  email,
  menu = true,
  chevronIcon = false
}: {
  email: string;
  menu?: boolean;
  chevronIcon?: boolean;
}) => {
  const name = emailToName(email) || "p.x";
  const avatarContent = <div className="flex flex-row items-center gap-2 cursor-pointer">
      <div className="w-8 h-8 flex flex-row items-center justify-center text-white rounded-full text-paragraph-small font-bold " style={{
      backgroundImage: nameToColorHash(name)
    }}>
        {nameToInitials(name)}
      </div>
      {menu && chevronIcon && <Icon icon={"akar-icons:chevron-down"} className="text-white" />}
    </div>;
  if (!menu) {
    return avatarContent;
  }
  return <Dropdown label="" dismissOnClick renderTrigger={() => avatarContent} className="rounded-lg px-3 py-6 gap-4" theme={{
    floating: {
      divider: "mt-6 mb-4 h-px bg-neutral-200"
    }
  }} data-sentry-element="Dropdown" data-sentry-component="DisconnectedAvatar" data-sentry-source-file="Avatar.tsx">
      <Dropdown.Header className="flex flex-col gap-1 px-3 py-0" data-sentry-element="unknown" data-sentry-source-file="Avatar.tsx">
        <span className="text-paragraph-large text-neutral-900 font-semibold capitalize">
          {name}
        </span>
        <span className="text-paragraph-small text-neutral-600 ">{email}</span>
      </Dropdown.Header>
      <Dropdown.Item className="text-paragraph-large text-neutral-900 font-medium flex items-center gap-3 rounded-lg" href="/auth/logout" data-sentry-element="unknown" data-sentry-source-file="Avatar.tsx">
        <Icon icon="bi:box-arrow-left" className="text-neutral-900 size-5" data-sentry-element="Icon" data-sentry-source-file="Avatar.tsx" />
        Log out
      </Dropdown.Item>
    </Dropdown>;
};
export default function Avatar({
  menu = true,
  chevronIcon = false
}: {
  menu?: boolean;
  chevronIcon?: boolean;
}) {
  const session = useSession();
  return <DisconnectedAvatar email={session?.email ?? ""} menu={menu} chevronIcon={chevronIcon} data-sentry-element="DisconnectedAvatar" data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx" />;
}